import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'antd';
import { Layers, ArrowRight, CheckCircle2, Play } from 'lucide-react';
import './FeatureAnnouncementModal.scss';

const STORAGE_KEY = 'dadan_feature_announcement_seen_v1';

interface FeatureAnnouncementModalProps {
  onExploreTemplates: () => void;
}

export const FeatureAnnouncementModal: React.FC<FeatureAnnouncementModalProps> = ({
  onExploreTemplates,
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hasSeenAnnouncement = localStorage.getItem(STORAGE_KEY);
    if (!hasSeenAnnouncement) {
      const timer = setTimeout(() => {
        setVisible(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  const handleExploreTemplates = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
    onExploreTemplates();
  };

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      width={580}
      className="feature-announcement-modal"
      maskClosable={false}
    >
      <div className="feature-announcement-content">
        <div className="hero-section">
          <div className="hero-illustration">
            <div className="scene-cards">
              <div className="scene-card scene-1">
                <div className="scene-thumbnail">
                  <Play size={16} fill="#4A3CFA" color="#4A3CFA" className="play-icon" />
                </div>
                <span>Intro</span>
              </div>
              <div className="scene-card scene-2">
                <div className="scene-thumbnail">
                  <Play size={16} fill="#4A3CFA" color="#4A3CFA" className="play-icon" />
                </div>
                <span>Content</span>
              </div>
              <div className="scene-card scene-3">
                <div className="scene-thumbnail">
                  <Play size={16} fill="#4A3CFA" color="#4A3CFA" className="play-icon" />
                </div>
                <span>Outro</span>
              </div>
            </div>
            <div className="connection-lines">
              <ArrowRight size={24} className="arrow" />
              <ArrowRight size={24} className="arrow" />
            </div>
          </div>
        </div>

        <div className="content-section">
          <div className="badge">
            <Layers size={14} />
            <span>New</span>
            <span className="badge-divider">•</span>
            <span>Scenes</span>
          </div>

          <h2 className="headline">
            Record smarter. Deliver better. Ship faster.
          </h2>

          <p className="body-text">
            Record in bite-size scenes, stitch them with smooth transitions, and level up your delivery with AI feedback and a built-in teleprompter.
          </p>

          <div className="feature-list">
            <div className="feature-item">
              <CheckCircle2 size={18} className="feature-icon" />
              <span>Scene-by-scene recording so mistakes don't ruin the whole take</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 size={18} className="feature-icon" />
              <span>Instant delivery insights to improve pace, filler words, and confidence signals</span>
            </div>
            <div className="feature-item">
              <CheckCircle2 size={18} className="feature-icon" />
              <span>Clean transitions that make the final cut feel seamless</span>
            </div>
          </div>

          <div className="cta-section">
            <Button
              type="primary"
              size="large"
              className="primary-cta"
              onClick={handleExploreTemplates}
            >
              Explore Scenes & Templates
              <ArrowRight size={16} />
            </Button>
            <button className="secondary-cta" onClick={handleDismiss}>
              Maybe later
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FeatureAnnouncementModal;
